import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import { gsap } from "gsap"
import { ScrollToPlugin } from 'gsap/all'
import ScrollMagic from 'scrollmagic'
import ModalVideo from 'modal-video'
import 'jquery-modal'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el);
  const opts = {
    basic: {
      autoplay: true,
      arrows: false,
      dots: true,
      infinite: true,
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "lazy",
  })
}



  /* NAV menu
    ----------------------------- */
    export const navMenu = () => {

        $(window).scroll(function(e) {
          $(document).scrollTop() > 200 ?
              $('.anchor__menu').addClass('sticky') :
              $('.anchor__menu').removeClass('sticky')

          this.oldScroll > this.scrollY ?
              $('.anchor__menu').addClass('sticky-show').removeClass('sticky-hide') :
              $('.anchor__menu').addClass('sticky-hide').removeClass('sticky-show')
          this.oldScroll = this.scrollY
        })
    }

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"]):not([href*="#modal"])').click(function(e) {
    const target = $(this.hash)
    if (target.length > 1) e.preventDefault()
    // TweenLite.to(window, 1, { scrollTo: target.offset().top-100 })
    $('html, body').animate({ scrollTop: target.offset().top-50 }, 1000)
  })

  $("a[href='#top']").click(function(e) {
    e.preventDefault()
    // TweenLite.to(window, .8, { scrollTo: 0 })
    $('html, body').animate({ scrollTop: 0 }, 800)
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  if (!$('.header--main').hasClass('initialized')) {
    const toggle = $('.header__toggle')
    const bar = $('.header__toggle .bar')
    const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
    const link = $('.header--offcanvas a');
    const header = $('.header--main');

    toggle.on('click', function () {
      overlay.toggleClass('open')
      bar.toggleClass('animate')
      toggle.toggleClass('open')
      header.toggleClass('shadow')
    })

    link.on('click', function () {
      overlay.removeClass('open')
      bar.removeClass('animate')
      toggle.removeClass('open')
    })

    window.onresize = () => {
      overlay.removeClass('open')
      bar.removeClass('animate')
      toggle.removeClass('open')
    }

    $(window).scroll(function(e) {
      $(document).scrollTop() > 200 ?
        header.addClass('sticky') :
        header.removeClass('sticky')

      this.oldScroll > this.scrollY ?
        header.addClass('sticky-show').removeClass('sticky-hide') :
        header.addClass('sticky-hide').removeClass('sticky-show')
      this.oldScroll = this.scrollY
    })

  $('.header--main').addClass('initialized')
}
}


  /* SETUP JQUERY MODAL
  ----------------------------- */
export const setupJqueryModal = () => {
  const link = $('[href*="#modal"]')

  link.on('click' , function(e) {
    $(this).modal({fadeDuration: 100,})
    e.preventDefault()
  })
}


/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}



// WEBPACK FOOTER //
// ./src/js/functions.js